import { InfoOutlined } from '@mui/icons-material';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { CustomTooltip } from '../../../utility/helpers/commonFunction';

const styles = {
    container: { width: '100%' },
    infoIcon: { fontSize: '18px', cursor: 'pointer' },
    tab: { fontWeight: 500 },
};

function a11yProps(index) {
    return {
        id: `appointment-tab-${index}`,
        'aria-controls': `appointment-tabpanel-${index}`,
    };
}

const TAB_LABELS = ['OUTSTANDING REQUESTS', 'ACCEPTED REQUESTS', 'PROPOSED NEW TIME', 'DECLINED REQUESTS', 'EXPIRED REQUESTS'];

const AppointmentRequestTabs = ({ value, onChange }) => {
    return (
        <Box sx={styles.container}>
            <Box display="flex" alignItems="center">
                <Tabs value={value} onChange={onChange} aria-label="appointment request tabs" variant="scrollable" scrollButtons="auto">
                    {TAB_LABELS.map((label, i) => (
                        <Tab
                            key={label}
                            label={
                                <Box display="flex" alignItems="center" gap={1}>
                                    {label}
                                    {label === 'EXPIRED REQUESTS' && (
                                        <CustomTooltip
                                            width="330px"
                                            placement="top"
                                            title={<Typography fontSize="14px">Appointments expired as they were not accepted within 24 hours</Typography>}
                                        >
                                            <InfoOutlined sx={{ ...styles.infoIcon, color: value !== 4 ? '#8C8C8C' : 'rgba(0, 108, 221, 1)' }} />
                                        </CustomTooltip>
                                    )}
                                </Box>
                            }
                            {...a11yProps(i)}
                            sx={styles.tab}
                        />
                    ))}
                </Tabs>
            </Box>
        </Box>
    );
};

export default AppointmentRequestTabs;
